module.exports = __webpack_public_path__ + "img/電気回路_4_4_2.f0d14ce0.png";